import {urlParams, getUrlParams} from '@/utils/urlParams';
import sleep from '@/utils/sleep';
import scrrroll from 'scrrroll';

export default function (dom, opts) {
	var options = {
		classes: {
			loading: 'products--loading',
		},
		selectors: {
			filter: '.products-filter',
			grid: '.products__grid',
			loadMore: '.products__load-more',
		},
		...opts
	};

	const filter = dom.querySelector(options.selectors.filter);
	const grid = dom.querySelector(options.selectors.grid);
	const loadMore = dom.querySelector(options.selectors.loadMore);

    if (filter) {
        filter.addEventListener('submit', e => {
            e.preventDefault();

            const formData = new FormData(filter);
            const data = {
                ...Object.fromEntries(formData),
                p: '',
            };

            updateUrl(data);
            scrrroll.toTop();
        });

        loadMore.addEventListener('click', loadMoreProducts);

    }
	window.addEventListener('replacestate', updateProducts);

	function updateUrl(data) {
		const object = {
			...getUrlParams(),
			...data,
		};
		const params = urlParams(object);
		const url = `${location.origin}${location.pathname}?${params}`;
		history.replaceState({url, date: Date.now()}, null, url);
	}

	function loadMoreProducts() {
		const params = getUrlParams();

		if (params.p) {
			params.p = ++params.p;
		}
		else {
			params.p = 2;
		}

		updateUrl(params);
	}

	async function updateProducts(replace = false) {
		// TODO: the response should be a json containing the html to (re)place
		// and a boolean to hide the load more button when the end is reached
		const query = location.search;
		const params = getUrlParams();
		const scrollPos = window.pageYOffset;
		const firstPage = !params.p || params.p == 1;

		if (firstPage) {
			grid.innerHTML = '';
		}

		dom.classList.add(options.classes.loading);
		firstPage || window.scrollTo(0, scrollPos);

		try {
			const response = await fetch(`/products.php${query}`);
			const data = await response.json();

			await sleep(1000); // TODO: remove this

			if (!data.nextPage) {
				loadMore.style.display = 'none';
			}
			else {
				loadMore.style.display = '';
			}

			grid.insertAdjacentHTML('beforeend', data.html);
			dom.classList.remove(options.classes.loading);
			firstPage || window.scrollTo(0, scrollPos);
		}
		catch(error) {
			loadMore.style.display = 'none';
		}
	}
}
